import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from './ui/dialog';
import { Button } from './ui/button';
import { Sparkles, ChevronDown, Check } from 'lucide-react';

const models = [
  { id: 'sonar', name: 'Sonar', icon: '✦', badge: null },
  { id: 'gemini-3-flash', name: 'Gemini 3 Flash', icon: 'G', badge: null },
  { id: 'gemini-3-pro', name: 'Gemini 3 Pro', icon: 'G', badge: null },
  { id: 'gpt-5.2', name: 'GPT-5.2', icon: '⚡', badge: null },
  { id: 'claude-sonnet-4.5', name: 'Claude Sonnet 4.5', icon: 'Aɪ', badge: null },
  { id: 'claude-opus-4.6', name: 'Claude Opus 4.6', icon: 'Aɪ', badge: 'Max' },
  { id: 'grok-4.1', name: 'Grok 4.1', icon: '𝕏', badge: null },
  { id: 'kimi-k2.5', name: 'Kimi K2.5', icon: 'K', badge: 'New', subtitle: 'Hosted in the US' }
];

const ModelSelector = ({ selectedModel, onModelSelect }) => {
  const [open, setOpen] = React.useState(false);
  const currentModel = models.find(m => m.id === selectedModel) || models[0];

  const handleSelect = (modelId) => {
    onModelSelect(modelId);
    setOpen(false);
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button
          data-testid="model-selector-trigger"
          variant="outline"
          className="rounded-full border-border/50 hover:border-primary/50 bg-card/50 backdrop-blur-sm px-3 sm:px-4 py-2 max-w-[90vw]"
        >
          <span className="text-lg mr-2">{currentModel.icon}</span>
          <span className="font-medium text-sm sm:text-base truncate max-w-[9rem] sm:max-w-none">{currentModel.name}</span>
          {currentModel.badge && (
            <span className="ml-2 text-xs px-2 py-0.5 rounded-full bg-primary/20 text-primary">
              {currentModel.badge}
            </span>
          )}
          <ChevronDown size={16} className="ml-2 text-muted-foreground" />
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-[calc(100vw-2rem)] sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="font-heading text-xl">Upgrade for best models</DialogTitle>
        </DialogHeader>
        <div className="space-y-2 mt-4">
          {models.map((model) => (
            <button
              key={model.id}
              onClick={() => handleSelect(model.id)}
              className="w-full flex items-center justify-between p-3 rounded-lg hover:bg-accent transition-colors group"
              data-testid={`model-option-${model.id}`}
            >
              <div className="flex items-center gap-3">
                <span className="text-2xl">{model.icon}</span>
                <div className="text-left">
                  <div className="flex items-center gap-2">
                    <span className="font-medium text-foreground">{model.name}</span>
                    {model.badge && (
                      <span className={`text-xs px-2 py-0.5 rounded-full ${
                        model.badge === 'Max' ? 'bg-primary/20 text-primary' : 'bg-secondary/20 text-secondary'
                      }`}>
                        {model.badge}
                      </span>
                    )}
                  </div>
                  {model.subtitle && (
                    <p className="text-xs text-muted-foreground">{model.subtitle}</p>
                  )}
                </div>
              </div>
              {selectedModel === model.id && (
                <Check className="text-primary" size={20} />
              )}
            </button>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ModelSelector;
